'use client'

import Image from 'next/image'

type BadgePlacement = {
  src: string
  size: number
  top: string
  right?: string
  left?: string
  rotate: number
  /** Hidden on mobile to reduce clutter; shown from sm breakpoint up */
  mobileHidden?: boolean
}

// Triangle layout: narrow at top (right edge only), widest at bottom (spread across)
const BADGES: BadgePlacement[] = [
  { src: '/img/badges/compliment_base.svg', size: 112, top: '5%', right: '2%', rotate: -8 },
  { src: '/img/badges/referral.svg', size: 80, top: '14%', right: '0%', rotate: 6, mobileHidden: true },
  { src: '/img/badges/careiq_base.svg', size: 100, top: '22%', right: '5%', rotate: -12, mobileHidden: true },
  { src: '/img/badges/shift-pickup-gold-v2.svg', size: 92, top: '32%', right: '-5%', rotate: 4, mobileHidden: true },
  { src: '/img/badges/compliment_5.svg', size: 72, top: '38%', right: '12%', rotate: -6 },
  {
    src: '/img/badges/shift-pickup-silver-v2.svg',
    size: 120,
    top: '45%',
    right: '-12%',
    rotate: 10,
  },
  { src: '/img/badges/careiq_fall.svg', size: 88, top: '52%', right: '8%', rotate: -5 },
  { src: '/img/badges/shift-pickup-base.svg', size: 76, top: '58%', right: '-18%', rotate: 7, mobileHidden: true },
  { src: '/img/badges/compliment_10.svg', size: 68, top: '64%', right: '2%', rotate: -9 },
  {
    src: '/img/badges/shift-pickup-platinum-v2.svg',
    size: 96,
    top: '70%',
    right: '-8%',
    rotate: 3,
  },
  { src: '/img/badges/compliment_base.svg', size: 84, top: '76%', right: '-25%', rotate: 5 },
  { src: '/img/badges/referral.svg', size: 64, top: '82%', right: '15%', rotate: -7 },
  { src: '/img/badges/careiq_base.svg', size: 90, top: '86%', right: '-35%', rotate: 8 },
  { src: '/img/badges/shift-pickup-gold-v2.svg', size: 78, top: '90%', right: '-5%', rotate: -4 },
  { src: '/img/badges/compliment_5.svg', size: 70, top: '92%', left: '55%', rotate: 6 },
  { src: '/img/badges/shift-pickup-silver-v2.svg', size: 102, top: '94%', right: '-45%', rotate: -6 },
  { src: '/img/badges/careiq_fall.svg', size: 74, top: '96%', left: '38%', rotate: 9 },
  { src: '/img/badges/shift-pickup-base.svg', size: 82, top: '98%', right: '-28%', rotate: -5 },
]

export default function BadgeWaterfall() {
  return (
    <div aria-hidden className="pointer-events-none fixed inset-0 z-0 overflow-hidden">
      <div className="absolute inset-0 origin-bottom-right scale-75 sm:scale-90 md:scale-100">
        {BADGES.map((badge, i) => (
          <div
            key={`${badge.src}-${i}`}
            className={`absolute transition-transform duration-300 ease-out ${badge.mobileHidden ? 'hidden sm:block' : ''}`}
            style={{
              top: badge.top,
              ...(badge.right !== undefined ? { right: badge.right } : {}),
              ...(badge.left !== undefined ? { left: badge.left } : {}),
              transform: `rotate(${badge.rotate}deg)`,
            }}
          >
            <Image
              src={badge.src}
              alt=""
              width={badge.size}
              height={badge.size}
              className="h-auto w-full opacity-[0.14] drop-shadow-sm"
              style={{ width: badge.size, height: badge.size }}
              sizes="(max-width: 640px) 72px, (max-width: 768px) 96px, 120px"
            />
          </div>
        ))}
      </div>
    </div>
  )
}
